/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_TitleInputs */



/**
* | output |
* | --- |
* | "Subtitle Styling" |
*
* @param {Video_Export_Style_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_title = /** @type {((inputs?: Video_Export_Style_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Style des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelformatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stile dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оформление субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estilo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕のスタイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपशीर्षक शैलीकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Estilização de legendas")
	return /** @type {LocalizedString} */ ("Subtitle Styling")
});